export default "__VITE_ASSET__C35REF7Z__"